export default class causaFalla{
	constructor($scope,
				$routeParams,
				method,
                causaFallaService,
				$location,
				toastr,
                $uibModal,
                tipoEquipoService
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(causaFallaService);
			break;
			case 'new':
				this.create(causaFallaService,tipoEquipoService);
			break;
			case 'view':
				this.view($routeParams,
                    causaFallaService,
                    tipoEquipoService);
			break;
		}
	}

	list(causaFallaService){
        let self = this.scope;
        causaFallaService.getAll().then((resp, err) => {
			self.causasDeFallas = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.causasDeFallas.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, causaFallaService);
	}

	create(causaFallaService, tipoEquipoService){

        this.scope.inAction = false;

        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.tipo_equipos = resp.data.message;
            });
            
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                causaFallaService.save(this.scope.causaDeFalla).then((resp) => {
                    this.toastr.success('Causa de falla creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/causa_falla_correctiva');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al crear la causa de falla!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

	view($routeParams,
         causaFallaService,
         tipoEquipoService){

		this.scope.aux = {};
        causaFallaService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.causaDeFalla = resp.data.message;
		}).catch((er) => {
			console.log(er);
        });
        
        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.tipo_equipos = resp.data.message;
            });

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                causaFallaService.update(this.scope.causaDeFalla).then((resp) => {
                    this.toastr.success('Causa de falla modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/causa_falla_correctiva');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la causa de falla!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,causaFalla, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Causa de falla</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la causa de falla: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = causaFalla.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: causaFalla._id}).then((resp) => {
                    self.scope.causasDeFallas.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Causa de falla eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error( 'Error al eliminar causa de falla!','Error', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/causa_falla_correctiva/causa_falla.js